/// <amd-module name="Build/Client/XAMLClient" />

//***   This is not auto generated file  ***/
import {IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";
import { deserializeVssJsonObject } from "VSS/Platform/Util/Serialization";

import * as Build from "Build/Client/Contracts/Build";
import * as VS_Services from "VSS/Platform/Contracts/WebApi";

export interface IXAMLBuildRestClient extends IVssRestClient {
   
    /**
     * Gets a list of builds.
     * 
     * @param project - Project ID or project name
     * @param definitions - A comma-delimited list of definition IDs. If specified, filters to builds for these definitions.
     * @param queues - A comma-delimited list of queue IDs. If specified, filters to builds that ran against these queues.
     * @param buildNumber - If specified, filters to builds that match this build number. Append * to do a prefix search.
     * @param minTime - If specified, filters to builds that finished/started/queued after this date based on the queryOrder specified.
     * @param maxTime - If specified, filters to builds that finished/started/queued before this date based on the queryOrder specified.
     * @param requestedFor - If specified, filters to builds requested for the specified user.
     * @param reasonFilter - If specified, filters to builds that match this reason.
     * @param statusFilter - If specified, filters to builds that match this status.
     * @param resultFilter - If specified, filters to builds that match this result.
     * @param tagFilters - A comma-delimited list of tags. If specified, filters to builds that have the specified tags.
     * @param properties - A comma-delimited list of properties to retrieve.
     * @param top - The maximum number of builds to return.
     * @param continuationToken - A continuation token, returned by a previous call to this method, that can be used to return the next set of builds.
     * @param maxBuildsPerDefinition - The maximum number of builds to return per definition.
     * @param deletedFilter - Indicates whether to exclude, include, or only return deleted builds.
     * @param queryOrder - The order in which builds should be returned.
     * @param branchName - If specified, filters to builds that built branches that built this branch.
     * @param buildIds - A comma-delimited list that specifies the IDs of builds to retrieve.
     * @param repositoryId - If specified, filters to builds that built from this repository.
     * @param repositoryType - If specified, filters to builds that built from repositories of this type.
     * @param type - If specified, built from definition of this type.
     */
    getXAMLBuilds(project: string, definitions?: number[], queues?: number[], buildNumber?: string, minTime?: Date, maxTime?: Date, requestedFor?: string, reasonFilter?: Build.BuildReason, statusFilter?: Build.BuildStatus, resultFilter?: Build.BuildResult, tagFilters?: string[], properties?: string[], top?: number, continuationToken?: string, maxBuildsPerDefinition?: number, deletedFilter?: Build.QueryDeletedOption, queryOrder?: Build.BuildQueryOrder, branchName?: string, buildIds?: number[], repositoryId?: string, repositoryType?: string, type?: number): Promise<VS_Services.PagedList<Build.Build>>;
  

}

class XAMLBuildRestClient extends RestClientBase implements IXAMLBuildRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    
    /**
     * Gets a list of builds.
     * 
     * @param project - Project ID or project name
     * @param definitions - A comma-delimited list of definition IDs. If specified, filters to builds for these definitions.
     * @param queues - A comma-delimited list of queue IDs. If specified, filters to builds that ran against these queues.
     * @param buildNumber - If specified, filters to builds that match this build number. Append * to do a prefix search.
     * @param minTime - If specified, filters to builds that finished/started/queued after this date based on the queryOrder specified.
     * @param maxTime - If specified, filters to builds that finished/started/queued before this date based on the queryOrder specified.
     * @param requestedFor - If specified, filters to builds requested for the specified user.
     * @param reasonFilter - If specified, filters to builds that match this reason.
     * @param statusFilter - If specified, filters to builds that match this status.
     * @param resultFilter - If specified, filters to builds that match this result.
     * @param tagFilters - A comma-delimited list of tags. If specified, filters to builds that have the specified tags.
     * @param properties - A comma-delimited list of properties to retrieve.
     * @param top - The maximum number of builds to return.
     * @param continuationToken - A continuation token, returned by a previous call to this method, that can be used to return the next set of builds.
     * @param maxBuildsPerDefinition - The maximum number of builds to return per definition.
     * @param deletedFilter - Indicates whether to exclude, include, or only return deleted builds.
     * @param queryOrder - The order in which builds should be returned.
     * @param branchName - If specified, filters to builds that built branches that built this branch.
     * @param buildIds - A comma-delimited list that specifies the IDs of builds to retrieve.
     * @param repositoryId - If specified, filters to builds that built from this repository.
     * @param repositoryType - If specified, filters to builds that built from repositories of this type.
     * @param type - If specified, built from definition of this type.
     */
    public async getXAMLBuilds(
        project: string,
        definitions?: number[],
        queues?: number[],
        buildNumber?: string,
        minTime?: Date,
        maxTime?: Date,
        requestedFor?: string,
        reasonFilter?: Build.BuildReason,
        statusFilter?: Build.BuildStatus,
        resultFilter?: Build.BuildResult,
        tagFilters?: string[],
        properties?: string[],
        top?: number,
        continuationToken?: string,
        maxBuildsPerDefinition?: number,
        deletedFilter?: Build.QueryDeletedOption,
        queryOrder?: Build.BuildQueryOrder,
        branchName?: string,
        buildIds?: number[],
        repositoryId?: string,
        repositoryType?: string,
        type?: number
        ): Promise<VS_Services.PagedList<Build.Build>> {

        const queryValues: any = {
            definitions: definitions && definitions.join(","),
            queues: queues && queues.join(","),
            buildNumber: buildNumber,
            minTime: minTime,
            maxTime: maxTime,
            requestedFor: requestedFor,
            reasonFilter: reasonFilter,
            statusFilter: statusFilter,
            resultFilter: resultFilter,
            tagFilters: tagFilters && tagFilters.join(","),
            properties: properties && properties.join(","),
            '$top': top,
            continuationToken: continuationToken,
            maxBuildsPerDefinition: maxBuildsPerDefinition,
            deletedFilter: deletedFilter,
            queryOrder: queryOrder,
            branchName: branchName,
            buildIds: buildIds && buildIds.join(","),
            repositoryId: repositoryId,
            repositoryType: repositoryType,
            type: type
         };


        return this.beginRequest<Response>({
            apiVersion: "2.2",      
            routeTemplate: "{project}/_apis/build/builds/{buildId}",
            routeValues: {
                project: project
            },
            queryParams: queryValues,
            returnRawResponse: true
        }).then(async response => {
            const body = <VS_Services.PagedList<Build.Build>>await response.text().then(deserializeVssJsonObject);
            body.continuationToken = response.headers.get("x-ms-continuationtoken");
            return body;
        });
    }

    

}

export const BuildClientName = "IXAMLBuildRestClient";

export function getBuildClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IXAMLBuildRestClient {
    return pageContext.getRestClient<IXAMLBuildRestClient>(BuildClientName, options);
}

RestClients.add(BuildClientName, { 
    factory: XAMLBuildRestClient,
    options: {
        resourceAreaId: "965220d5-5bb9-42cf-8d67-9b146df2a5a4",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});